import constants from "../../core/constants";
import { formatKey } from "../../core/utils";
import moment from "moment";

class FineReimbursementPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    data.reason = data.reason && data.reason.title_i18n.en;
    data.operator_reason =
      data.operator_reason && data.operator_reason.title_i18n.en;
    data.amount /= constants.currencyBy;
    data.date = moment(data.date).format(constants.dateFormat);
    data.status = formatKey(data.status);

    return data;
  }
}

export default FineReimbursementPageTransform;



// WEBPACK FOOTER //
// ./src/pages/fineReimbursement/fineReimbursement.transforms.js